import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';

export const mayPromo2025YearProduct: string = getFeature('may-promo-2025-year-product');
export const mayPromo2025YearProductId: string = getFeature('may-promo-2025-year-product-id');
export const mayPromo2025MonthProduct: string = getFeature('may-promo-2025-month-product');

export const mayPromo2025: boolean =
    !IS_PAID_USER &&
    !IS_BIZ_USER &&
    promotionEndDate &&
    mayPromo2025YearProduct &&
    mayPromo2025YearProductId &&
    mayPromo2025MonthProduct &&
    getFeature('may-promo-2025');

registerExperiment(
    'may-promo-2025',
    '',
    [AnalyticEventNames.MAY_PROMO_2025_BUY_TARIFF_SHOW, AnalyticEventNames.MAY_PROMO_2025_BUY_TARIFF_CLICK],
    {
        mapEventNames: {
            MAY_PROMO_2025_BUY_TARIFF_SHOW: 'show',
            MAY_PROMO_2025_BUY_TARIFF_CLICK: 'click',
        },
    }
);
